export const marcas = [
  { nombre: "RIGENERA", tipo: "Tecnología" },
  { nombre: "SYLFIRMX", tipo: "Tecnología" },
  { nombre: "EMERALD", tipo: "Tecnología" },
  { nombre: "JOVENA", tipo: "Tecnología" },
  { nombre: "HYPER PULSE", tipo: "Tecnología" },
  { nombre: "IMPERIUM MED 400", tipo: "Tecnología" },
  { nombre: "BODYSTIM", tipo: "Tecnología" },
  { nombre: "ADVA", tipo: "Tecnología" },
  { nombre: "NEOGEN", tipo: "Tecnología" },
  { nombre: "ENYGMA", tipo: "Tecnología" },
  { nombre: "CRYSTAL 3D PLUS", tipo: "Tecnología" },
  { nombre: "TARGETCOOL", tipo: "Tecnología" },
  { nombre: "LAVIEEN", tipo: "Tecnología" },
  { nombre: "FX405", tipo: "Tecnología" },
  { nombre: "GVL", tipo: "Tecnología" },
  { nombre: "PLASMAGE", tipo: "Tecnología" },
  { nombre: "HEBE", tipo: "Tecnología" },
  { nombre: "MELINE", tipo: "Insumo" },
  { nombre: "PBSERUM HA", tipo: "Insumo" },
  { nombre: "SMARTKER", tipo: "Insumo" },
  { nombre: "GOURI", tipo: "Insumo" },
];